const token = ['sephira', 'token']

export const billingSephiraKey = {
  token,
}
